import React from 'react';

// Tilde de perfil verificado: azul (selfie) o dorado (cuenta oficial)
export default function BadgeVerificado({ show, dorado }) {
  if (!show) return null;
  return (
    <span className={`badge-verificado${dorado ? ' badge-verificado--dorado' : ''}`}
      title={dorado ? 'Perfil verificado oficial' : 'Perfil verificado con selfie'} aria-label="Perfil verificado">✓</span>
  );
}
